import { ISvgIcon } from 'types/interfaces';

export default function SvgIcon({ Icon, className, color, style, onClick, ariaLabel }: ISvgIcon) {
  return (
    <Icon
      aria-label={ariaLabel ? ariaLabel : 'dfv'}
      className={className}
      style={{ ...style}}
      onClick={() => onClick && onClick()}
    >
      <path fill={color ? color : 'black'}/>
    </Icon>
  );
}
